// src/locales/zh.js
export default {
  automotiveInfrastructure: {
    Automotive: '汽车领域',
    heroDesc: '汽车行业的变革既给传统商业模式带来了重大挑战，也使得我们能以战略顾问的角色与您一起面对巨大机遇。',
    contactUs: '联系我们',
    innovationTitle: '产品与服务的创新机遇',
    innovationDesc: '全球汽车供应链及零部件行业向电气化、智能化转型的关键趋势，促使我们主动拥抱变化，并与新生态伙伴紧密合作。',
    insuranceTitle: '基于使用量的保险（UBI）黄金时代',
    insuranceDesc: '海量实时驾驶数据推动保险模式从“为车辆投保”转向“为驾驶行为投保”，实现更精准的风险筛选与定价服务。',
    preventionTitle: '从被动赔付到主动预防',
    preventionDesc: '我们的角色已从被动赔付方，升级为您的风险管理与服务合作伙伴。',
    partnershipTitle: '新型合作伙伴关系',
    partnershipDesc: '我们会与前端设备制造商（OEM）、电池能源厂商、算法公司及数据平台建立深度新型合作，获取数据、理解技术、联合开发产品并界定风险。',
    partnerTitle: '伴您驶向未来的可信合作伙伴',
    specializationTitle: '打造高度专业化能力',
    specializationDesc: '培养兼具保险专业知识与新兴汽车技术（如电气化、自动驾驶）的跨学科团队。',
    technologyTitle: '拥抱科技与数据',
    technologyDesc: '投入建设先进的数据分析能力，将车辆及驾驶数据转化为客户可落地的风险管理洞察。',
    productTitle: '推动产品创新',
    productDesc: '主动与保险公司合作，开发设计新型保障方案，应对电池故障、网络责任、自动驾驶系统故障等新兴风险。',
    serviceTitle: '升级服务内容',
    serviceDesc: '从保单承保与管理，我们将为您提供全生命周期的风险管理咨询服务，成为您不可或缺的战略伙伴。',
    Infrastructure: '基建领域',
    infrastructureDesc: '受新兴市场投资、数字化与绿色转型加速推进及部分行业订单激增的影响，基础建设增长呈现区域差异。',
    supportTitle: '我们提供哪些支持？',
    protectionTitle: '提供风险保障',
    protectionDesc: '为基建项目中的财产、工程质量、责任等风险提供保险保障，降低意外损失带来的财务压力。',
    financingTitle: '支持资金融资',
    financingDesc: '通过保险资金参与基建投资，为项目提供长期稳定资金，缓解融资难题。',
    managementTitle: '协助风险管理',
    managementDesc: '凭借专业经验，帮助项目识别、评估并防范风险，提升基建项目的抗风险能力。',
    greenTitle: '推动绿色转型',
    greenDesc: '开发绿色保险产品，支持绿色基建项目，助力基建领域实现可持续发展。',
    cooperationTitle: '促进国际合作',
    cooperationDesc: '为海外基建项目提供保险服务，协助中国基建“走出去”，保障跨国项目顺利实施。'
  },

  // ... existing code ...
  aboutUs: {
    heroTitle: "关于耀达",
    whoWeAre: "公司简介",
    integrity: "正直",
    diligence: "勤奋",
    innovation: "创新",
    urgent: "急",
    author: "作者",
    postedOn: "发布时间",
    recruitmentPositions: "招聘岗位",
    introductionText1: "耀达保险代理（SWI）是一家专业服务于企业的创新型保险中介机构，致力于为企业客户提供一站式、定制化的保险咨询与风险管理解决方案。公司成立于2009年，隶属于耀达咨询集团，依托上海、香港及洛杉矶三地的专业团队，构建覆盖全球的服务支持体系，精准对接企业国际化与本地化并行的保险保障需求。",
    introductionText2: "十余年来，我们已为股权投资、房地产开发、会展、科技、制造、生物医药、文化艺术等多个行业的企业提供了专业服务，积累了深厚的行业风险认知与应对经验。核心业务覆盖企业财产险、责任保险、员工福利保障以及并购保险等关键领域，致力于为企业提供兼具专业深度与成本效益的保险架构设计，助力企业实现风险管控与经营稳定。我们始终以企业持续发展为己任，通过前瞻性的风险洞察与专业的执行服务，为企业客户构建安全、高效的保险保障体系，成为值得企业长期信赖的风险管理伙伴。",
    teams: "管理团队",
    lefName: "张剑锋<br /> 创始人 & CEO",
    rightName1: "吕寅峰",
    rightName2: "朱宁馨",
    rightName3: "华晨飞",
    rightName4: "张玥",
    rightName5: "郭孟嘉",
    rightName6: "陈广发",
    businessDevelopment: "业务拓展",
    marketing: "市场营销",
    integratedServices: "综合服务",
    finpro: "金融及专业责任服务",
    customerServices: "客户服务",
    supporting: "运营支持",
    teamsText: "我们通过创新思维、专业知识和客户至上的理念，共同重新定义保险经纪服务。",
    aiAdvisorTitle: "AI保险顾问",
    aiAdvisorDesc: "“达达”是耀达（SWI）自主研发的AI保险顾问，依托先进人工智能技术，为保险服务体验带来全面革新：",
    preciseInterpretation: "保险产品精准解析",
    preciseInterpretationDesc: "通过持续优化的专有数据库，清晰解读各类保险产品，化繁为简，让条款一目了然。",
    availability: "7天24小时全天候服务",
    availabilityDesc: "提供即时、不间断的在线服务，简化需求评估与方案比对流程，提升行业智能效率，为客户创造切实价值。",
    leveragingAi: "洞悉客户需求",
    leveragingAiDesc: "耀达（SWI）通过人工智能技术深度挖掘客户需求，聚焦客户团队的高价值的战略分析与决策支持。",
    coreFunctions: "人工智能客户管理系统的三大核心功能：",
    policyVisualization: "保单可视化：",
    policyVisualizationDesc: "自动上传、即时查阅",
    coverageOptimization: "保障优化：",
    coverageOptimizationDesc: "智能分析保障缺口，主动提供优化建议",
    aiCustomerService: "AI智能客服：",
    aiCustomerServiceDesc: "即时响应，专业解答各类保险咨询",
    latestFromSwi: "最新动态",
    biomedicalConference: "生物医药创新集团 IMPACT 会议",
    biomedicalDesc: "第十一届BiG IMPACT年会“冲浪BiG浪潮”于2025年9月26-27日在上海举办。耀达（SWI）在会议现场设立专业展位，团队为与会嘉宾提供一对一的定制化保险解决方案咨询。",
    superReturnEvent: "2025 SuperReturn Asia 峰会",
    superReturnDesc: "在2025年于新加坡举办的SuperReturn Asia峰会上，耀达（SWI）展位吸引了众多海内外参会者莅临交流，有效强化了品牌在国际市场的声量。",
    networkingForum: "马来西亚 networking 交流论坛",
    networkingDesc: "2025年8月25日，耀达（SWI）与戈壁创投在吉隆坡联合主办行业论坛。活动汇聚近百位专业人士，就财务管理与风险应对的实践路径进行了深度分享与探讨。",
    cybersecuritySeminar: "7月苏州 • 企业赴港上市专题研讨会",
    cybersecurityDesc: "7月24日-25日，由证券时报社、招商银行苏州分行共同主办，香港公司治理公会提供支持的“潮起香江·顺势共赢——企业赴港上市专题研讨会”在苏州工业园区成功举办。",
    fineArtSeminar: "艺术品风险洞察研讨会",
    fineArtDesc: "2025年5月29日，耀达（SWI）与华泰保险集团在深圳太子湾K11艺术空间联合举办艺术品风险洞察研讨会。活动聚焦艺术与商业的共生关系，探讨了艺术品资产的风险管理与价值传承创新路径。",
    doReport: "耀达AI保险顾问——达达正式亮相",
    doReportDesc: "外部环境快速变化 行业亟待升级，我国保险深度与密度未来仍存巨大提升空间，这既为行业带来广阔前景，也对服务质效提出更高要求。",
    licenseRenewalAnnouncement: "换领保险中介许可证公告",
    licenseRenewalDesc: "由于公司经营地址变更，我司已于2026年1月6日换领新版保险中介业务许可证。",
    scanQrCode: "扫描二维码关注耀达官方微信公众号。",
    shanghai: "上海",
    hongKong: "香港",
    singapore: "新加坡",
    shanghaiCompany: "上海耀达保险代理有限公司",
    shanghaiAddress: "上海市长宁区娄山关路523号金虹桥国际中心1座1206室",
    shanghaiPhone: "公司总机：",
    shanghaiHotline: "客服热线：",
    hongKongCompany: "耀达保险经纪（香港）有限公司",
    hongKongAddress: "香港金钟道 89 号力宝中心二座 16 楼 12 室",
    hongKongPhone: "公司总机：",
    hongKongEmail: "客服邮箱：",
    sanFrancisco: "洛杉矶",
    sanFranciscoCompany: "Sun Wisdom Insurance Services Inc.",
    sanFranciscoAddress: "811 West 7th Street Suite 1200, Los Angeles, CA 90017",
    sanFranciscoPhone: "公司总机：",
    sanFranciscoEmail: "客服邮箱：",
    CAREERLISTINGS: '',
    JoinOurTeam: '加入我们',
    Joinustotransform: '耀达始终将人才视为企业最宝贵的资产，致力于打造一个专业协作、持续成长的职业发展平台。',
    Joinustotransform1: '我们重视每一份才华，为您提供施展能力的空间与系统化的专业支持。通过实战培养、跨区域协同与前瞻性培训，助力您不断提升专业能力，实现个人与企业的共同成长。',
    Joinustotransform2: '我们秉持“正直、勤奋、创新”的文化理念，为员工提供清晰的成长路径与积极的工作氛围。在这里，您将与公司并肩前行，在专业领域持续深耕，共创长远价值。',
    learnMore: '了解更多',
    
    Shanghai:"上海",
    HongKong:"香港",
    Singapore:"新加坡",
    LosAngeles:"洛杉矶",

    Location: '位置',
    Team: '团队',
    EmploymentType: '职位类型',
    all: '全部',
    Fulltime: '全职',

    // 职位分类
    FinancialLines: '财务状况',
    EmployeeBenefits: '财务状况/员工福利',
    BusinessDevelopment: '业务拓展',
    Marketing: '营销',
    HumanResources: '人力资源',
    Management: '管理',

    // 职位标题
    legalClaimsManager: "法律理赔经理（金融险条线）",
    teamLeadFinancialLines: "团队负责人（金融险条线和员工福利优先）",
    teamLeadHongKong: "团队负责人（香港  金融险条线/员工福利方向）",
    accountManager: "客户经理/高级客户经理（香港  金融险条线和员工福利）",
    bdManagerChineseCompanies: "商务发展经理（专注拓展美国市场的中国企业）",
    bdManagerHighEndMedical: "商务发展经理（高端医疗保险）",
    businessDevelopmentManager: "商务发展经理",
    channelDevelopmentManagerCFO: "渠道发展经理（CFO生态系统方向）",
    foEcosystemDevelopmentLead: "FO生态系统发展负责人",
    channelDevelopmentManagerHongKong: "渠道发展经理（香港  CFO生态系统方向）",
    hrManager: "人力资源经理（专注人才招聘）",
    headOfSingaporeBranch: "新加坡分公司负责人",
    newMediaOperationsManager: "新媒体运营经理（面向CFO生态圈）",
    bdManagerCA: "业务拓展经理",

    // Legal Claims Manager (Financial Lines) 职位详情
    legalClaimsManagerJobDesc: "作为我们全球理赔团队的关键成员，您将通过专业的理赔管理、战略渠道合作和深入的保单条款分析，为公司客户提供全面的风险保障解决方案。您的工作对提升客户满意度和加强我们在金融险条线的声誉至关重要。",

    // Legal Claims Manager (Financial Lines) 职位详情
    legalClaimsManagerResp1: "负责企业客户财务线条产品（如董责险、职业责任险）的端到端理赔流程，包括案件评估、文件准备、与保险公司谈判以及持续跟进，确保高效和专业的解决。",
    legalClaimsManagerResp2: "定期对核心保单条款进行深入分析和市场研究，利用洞察优化客户保障方案，提升其竞争地位和风险保障。",
    legalClaimsManagerResp3: "与律师事务所渠道建立并维持协作关系，识别专业责任/财务线条领域的客户需求，开发创新保险解决方案。",
    legalClaimsManagerResp4: "为各地办事处提供法律相关支持、行业合规协助及其他专业法律服务。",
    legalClaimsManagerQual1: "全日制本科及以上学历。海外知名院校研究生学历优先。要求仪表专业，英语工作熟练。",
    legalClaimsManagerQual2: "至少2年律师事务所（专注资本市场）或保险经纪/公司（处理财务线条理赔）相关工作经验。",
    legalClaimsManagerQual3: "出色的专业形象、跨文化沟通技巧和客户关系管理能力，能有效与全球企业客户互动。",
    legalClaimsManagerQual4: "有处理涉及美国/香港上市证券的财务线条诉讼经验者优先。",
    legalClaimsManagerQual5: "有业务发展经验或在此领域有发展潜力者优先。",

    // Team Lead(Financial Lines & Employee Benefits Preferred) 职位详情
    teamLeadShanghaiJobDesc: "作为我们企业保险业务的核心领导者，您将负责建设和领导一支专注于服务高价值企业客户的精英团队。您将推动可扩展的业务增长，进一步加强我们在全球保险领域的市场地位和品牌影响力。",
    teamLeadShanghaiResp1: "全面负责团队建设和开发，包括招聘、培训和绩效管理，打造高绩效文化，持续提升团队专业能力和执行力。",
    teamLeadShanghaiResp2: "带领团队开拓新业务，确保年度新业务经纪费超过200万元人民币。",
    teamLeadShanghaiResp3: "制定并执行与公司目标一致的明确业务发展战略，定义目标市场、客户细分和实施方案路线图，以实现并超越业务目标。",
    teamLeadShanghaiResp4: "确保团队为客户提供专业和前沿的风险咨询和保险解决方案。主导关键客户的谈判和交付，持续提升客户满意度和盈利能力。",
    teamLeadShanghaiQual1: "本科及以上学历；海外知名院校研究生学历优先。",
    teamLeadShanghaiQual2: "外资保险经纪公司至少5年相关工作经验，目前管理的业务年经纪费持续超过200万元人民币。",
    teamLeadShanghaiQual3: "深入了解至少一种企业财产保险产品，熟悉行业动态和服务模式。",
    teamLeadShanghaiQual4: "在目标保险线拥有成熟的客户关系或渠道网络，具备整合资源和有效推动业务增长的能力。",

    // Team Lead (Hong Kong  Financial Lines / Employee Benefits Focus) 职位详情
    teamLeadHongKongJobResponsibilities: "工作职责:",
    teamLeadHongKongResp1: "主导并执行全面的市场策略，获取企业保险新客户，优先考虑财务线条和高价值员工福利/团体医疗保健业务。",
    teamLeadHongKongResp2: "代表公司在重要的行业活动和论坛上亮相，识别新兴机会，转化潜在客户，建立强大的专业网络。",
    teamLeadHongKongResp3: "培育并深化与保险公司合作伙伴和关键企业客户的长期战略关系，提升客户满意度、留存率和业务增长。",
    teamLeadHongKongResp4: "全面负责团队的业务目标，推动业绩表现，确保所有关键目标和KPI的成功达成。",
    teamLeadHongKongResp5: "领导团队管理的各个方面，包括人才招聘、培训、绩效评估和专业技能的持续发展。",
    teamLeadHongKongQualificationsRequirements: "资格要求:",
    teamLeadHongKongQual1: "全日制本科及以上学历，海外知名院校毕业生优先；仪表专业，普通话沟通流利",
    teamLeadHongKongQual2: "最少5年香港企业财产保险市场营销或关键客户管理经验。有财务线条（如董责险、职业责任险）或员工福利（企业团体医疗）直接经验者优先。",
    teamLeadHongKongQual3: "深入了解香港企业保险市场，具有良好的业绩记录和目标保险线的客户/合作伙伴关系网络。必须展现出强大的资源整合和业务发展能力。",
    teamLeadHongKongQual4: "持有相关香港保险中介人牌照（1、2、3、4、5类和强积金）。我们致力于支持优秀候选人在入职时获得任何缺少的牌照。",

    // Account Manager / Senior Account Manager (Hong Kong  Financial Lines & Employee Benefits) 职位详情
    accountManagerHongKongJobResponsibilities: "工作职责:",
    accountManagerHongKongResp1: "独立管理财务线条和员工福利的全套客户服务，包括市场报价、方案构建、提案分析和理赔支持。核心关注担保与赔偿（W&I）、董事及高级职员责任（D&O）保险和投资管理保险（IMI），次要支持网络、职业赔偿（PI）和其他企业保险。",
    accountManagerHongKongResp2: "定期对关键保险产品进行保单条款比较，分析差异，并根据客户的具体风险敞口提供专业建议以优化客户保障方案。",
    accountManagerHongKongResp3: "高效专业地处理理赔通知和流程，作为客户和保险公司之间的关键联络人，确保高标准的服务交付和客户满意度。",
    accountManagerHongKongResp4: "通过参与客户拜访、提供专业技术支持和帮助维护深化客户关系来支持业务发展，推动客户留存、新业务和交叉销售机会。",
    accountManagerHongKongQualificationsRequirements: "资格要求:",
    accountManagerHongKongQual1: "全日制本科及以上学历，海外知名院校毕业生优先；仪表专业，普通话沟通流利",
    accountManagerHongKongQual2: "至少2年财务线条和/或员工福利/企业团体医疗保险相关经验，对香港保险市场有扎实了解。",
    accountManagerHongKongQual3: "仪表专业、表达清晰，具备强大的沟通和客户服务技巧。",
    accountManagerHongKongQual4: "持有香港保险中介人资格考试（IIQE）第2卷（或同等资格）。",

    // Business Development Manager (Focus on Chinese Companies Expanding to the U.S.) 职位详情
    bdManagerChinaUSJobDesc: "作为我们业务发展团队的关键成员，您将致力于开发和培育中国企业拓展美国市场的业务。您将通过专业的关系管理和咨询式销售来推动业务增长。",
    bdManagerChinaUSKeyResponsibilities: "主要职责:",
    bdManagerChinaUSResp1: "负责识别、开发和维护与中国企业拓展美国市场的长期、稳定和基于战略信任的关系。",
    bdManagerChinaUSResp2: "深入了解并准确分析出境客户的保险需求，与美国团队合作，量身定制并提供一站式财产和意外险解决方案。",
    bdManagerChinaUSResp3: "独立管理从潜在客户开发、谈判到最终签约的端到端流程，确保高效转化，并努力达到或超越设定的业务目标。",
    bdManagerChinaUSQualifications: "资格要求:",
    bdManagerChinaUSQual1: "本科及以上学历，优秀的英语口语沟通能力；有美国学习经历者优先。",
    bdManagerChinaUSQual2: "最少2年为中国企业拓展美国市场提供服务或业务发展的相关经验。",
    bdManagerChinaUSQual3: "曾在会计师事务所、律师事务所、咨询公司、跨境银行、人力资源或企业服务领域工作过者优先。",
    bdManagerChinaUSQual4: "强大的客户获取技能和咨询式销售技巧，结果导向，能在压力下有效工作。",
    bdManagerChinaUSQual5: "有直接针对美国境内中国企业的营销或销售经验者优先。",

    // BD Manager – Individual High-End Medical Insurance 职位详情
    bdManagerMedicalJobDesc: "该职位负责公司高端医疗保险产品的市场拓展和销售，重点服务于高净值个人和家庭客户，并提供专业的保险规划和持续的客户服务。",
    bdManagerMedicalKeyResponsibilities: "主要职责:",
    bdManagerMedicalResp1: "执行高端医疗保险产品的市场推广和销售策略，并基于现有资源系统性地开发高净值个人和家庭客户群体。",
    bdManagerMedicalResp2: "根据客户需求提供高端医疗保障解决方案的专业规划、产品介绍和保险咨询。",
    bdManagerMedicalResp3: "维护和深化与现有高端客户的关系，进行定期回访，并协助处理保单服务、理赔处理和其他相关服务。",
    bdManagerMedicalResp4: "高效完成上级安排的其他任务。",
    bdManagerMedicalQualifications: "资格要求:",
    bdManagerMedicalQual1: "本科及以上学历；能流利说英语者优先。",
    bdManagerMedicalQual2: "在外资保险经纪公司或保险公司拥有超过2年的相关经验，有高端医疗保险或员工福利方面的经验者优先。",
    bdManagerMedicalQual3: "熟悉高端医疗保险产品的特点和行业趋势，具备强烈的市场意识。",
    bdManagerMedicalQual4: "出色的沟通技巧，能够识别客户需求，具备强大的谈判能力。",

    // BD Manager – CA 职位详情
    bdManagerCAResp1: "1.在美国市场主动开拓持牌范围内的各类商业保险新客户，包括中资企业、初创公司及本地企业，达成既定销售目标。",
    bdManagerCAResp2: "2.负责从客户询价、风险分析、方案设计、报价到成交的完整销售流程，能够独立推进项目落地。",
    bdManagerCAResp3: "3.深入了解客户经营模式与风险需求，通过专业沟通与关系维护，持续挖掘增值机会，实现多险种交叉销售。",
    bdManagerCAResp4: "4.跟踪美国商业保险市场动态，分析竞争产品及条款变化，为销售策略优化提供洞察建议。",
    bdManagerCAResp5: "5.与承保公司、合作伙伴以及内部团队保持良好协作，确保流程顺畅并持续提升客户体验。",
    bdManagerCAResp6: "6.根据公司需要，参与重要客户活动、行业论坛及品牌推广活动的组织与现场支持，协助公司加强市场影响力与客户关系。",
    bdManagerCAQualifications: "资格要求:",
    bdManagerCAQual1: "1.本科及以上学历，具备在美国从事保险相关工作的经验者优先，如担任 broker、producer 或其他面向客户的保险从业岗位。",
    bdManagerCAQual2: "2.专业形象佳，具备良好的客户沟通能力、商务表达能力与方案呈现能力。",
    bdManagerCAQual3: "3.至少两年以上商业保险或财产险销售经验，熟悉客户开发、需求分析、方案呈现与签约等环节。",
    bdManagerCAQual4: "4.自驱力强，结果导向，愿意在成长型团队中承担业务拓展责任，并具备一定的抗压能力。",
    bdManagerCAQual5: "5.熟悉美国商业保险产品体系（如 General Liability、Property、Workers’ Compensation、Commercial Auto 等）者优先；了解中资企业或跨境企业风险需求者更佳。",
    bdManagerCAQual6: "6.具备良好的执行能力与协作能力，愿意在活动组织、嘉宾沟通与会务支持等方面提供必要协助。",

    newMediaOperationsManagerResp1: "1.制定并推动CFO生态圈的整体发展战略，构建集会员成长、深度内容与精准资源对接于一体的完整运营体系。",
    newMediaOperationsManagerResp2: "2.主导策划并落地如行业论坛、闭门研讨会、专业沙龙等线上线下活动，打造CFO群体高度认可的交流阵地。",
    newMediaOperationsManagerResp3: "3.拓展并深化与券商、投行、律所、会所等核心机构的战略协同，构建高效联动的CFO生态资源网络。",
    newMediaOperationsManagerResp4: "4.搭建并精细化运营CFO专属社群，设计符合其圈层特性的互动机制，提升社群活跃度与成员归属感。",
    newMediaOperationsManagerResp5: "5.建立科学的生态价值评估模型，持续追踪关键指标，推动运营策略迭代，确保生态圈的长期活力与价值增长。",
    newMediaOperationsManagerMedicalQual1: "1.全日制本科及以上学历，海外知名院校背景优先；拥有成熟的CFO层级沟通经验与出色的商务形象，英语沟通流利。",
    newMediaOperationsManagerMedicalQual2: "2.5年以上高端财经社群运营、金融机构战略合作或面向CFO群体的深度服务经验，有从0到1搭建CFO社群的成功案例者优先。",
    newMediaOperationsManagerMedicalQual3: "3.具备出色的内容策划与专业文案能力，能够准确把握CFO关注的核心议题，并策划具有影响力的传播内容。",
    newMediaOperationsManagerMedicalQual4: "4.深刻理解上市公司治理、资本运作及CFO职责场景，能精准切入其沟通语境，并已积累相当的CFO层别人脉资源。",
    newMediaOperationsManagerMedicalQual5: "5.卓越的战略思维与资源整合能力，能够独立推动复杂项目落地，并实现生态价值的持续转化。",


    // Business Development Manager 职位详情
    businessDevelopmentManagerResponsibilities: "职责:",
    businessDevelopmentManagerResp1: "积极开发美国市场内公司执照范围内的新商业保险客户，包括中国企业、初创企业和本地企业，并完成分配的销售目标。",
    businessDevelopmentManagerResp2: "管理从询价、风险评估、方案设计和报价到成交的整个销售周期，具备独立推动项目执行的能力。",
    businessDevelopmentManagerResp3: "深入了解客户的运营和风险状况。保持牢固的关系以识别额外需求，并通过交叉销售机会最大化客户价值。",
    businessDevelopmentManagerResp4: "监控美国商业保险市场的趋势、竞争产品和政策变化，提供洞察以支持战略规划。",
    businessDevelopmentManagerResp5: "与承保人、合作伙伴和内部团队密切合作，确保流程顺畅并持续改善客户体验。",
    businessDevelopmentManagerResp6: "根据需要支持重要客户活动、行业论坛和品牌活动的策划和执行，为市场知名度和客户参与度做贡献。",
    businessDevelopmentManagerRequirements: "要求:",
    businessDevelopmentManagerReq1: "本科及以上学历。有美国保险行业工作经验者优先，如担任经纪人、代理人或其他面向客户的工作。",
    businessDevelopmentManagerReq2: "仪表专业，具备强大的沟通、人际交往和演示技巧。",
    businessDevelopmentManagerReq3: "至少两年商业保险或财产意外险销售经验，熟悉从寻找潜在客户到成交的整个销售过程。",
    businessDevelopmentManagerReq4: "自我激励，结果导向，能在成长型组织中舒适工作并具备抗压能力。",
    businessDevelopmentManagerReq5: "熟悉美国商业保险产品（如一般责任险、财产险、工伤赔偿、商业汽车险）者优先。有为中国企业或跨境客户服务的经验是加分项。",
    businessDevelopmentManagerReq6: "具备强大的执行和团队合作能力，愿意在需要时协助活动协调、客户沟通和现场支持。",

    // Channel Development Manager (CFO Ecosystem Focus) 职位详情
    channelDevelopmentManagerCFOJobResponsibilities: "工作职责:",
    channelDevelopmentManagerCFOResp1: "开发并维护与上市公司和拟上市公司首席财务官密切相关的关键渠道资源的长期战略合作关系，包括但不限于证券公司、投资银行、律师事务所、会计师事务所和行业协会。",
    channelDevelopmentManagerCFOResp2: "主导、共同组织或参与各种线上线下活动，如行业论坛、闭门研讨会和专业沙龙，提升公司在首席财务官群体中的专业影响力。",
    channelDevelopmentManagerCFOResp3: "准确接触目标首席财务官群体，促进客户资源的有效转化，并持续深化客户关系以实现长期价值培养。",
    channelDevelopmentManagerCFOQualifications: "资格要求:",
    channelDevelopmentManagerCFOQual1: "全日制本科及以上学历，海外名校优先；仪表专业，沟通风格得体，能融入首席财务官圈子并建立有意义的对话。",
    channelDevelopmentManagerCFOQual2: "最少2年证券/金融、律师事务所、专业服务或高端渠道合作经验，拥有成熟的机构网络和客户关系。",
    channelDevelopmentManagerCFOQual3: "精通渠道谈判和联合活动策划，具备强大的资源整合和项目执行能力。",
    channelDevelopmentManagerCFOQual4: "熟悉首席财务官沟通场景和业务重点，能够准确识别核心需求并建立信任关系。",

    // FO Ecosystem Development Lead 职位详情
    foEcosystemDevelopmentLeadKeyResponsibilities: "主要职责:",
    foEcosystemDevelopmentLeadResp1: "开发并推动首席财务官生态系统整体战略发展，构建一个结合成员增长、深度内容和精准资源配置的综合运营体系。",
    foEcosystemDevelopmentLeadResp2: "主导高水平线上线下活动的策划和执行，如行业论坛、闭门研讨会和专业沙龙，建立首席财务官社区高度认可的交流平台。",
    foEcosystemDevelopmentLeadResp3: "扩展和深化与证券公司、投资银行、律师事务所和会计师事务所等核心机构的战略合作，构建高效互联的首席财务官生态系统资源网络。",
    foEcosystemDevelopmentLeadResp4: "建立并精心管理专属首席财务官社区，设计与其专业特点相符的参与机制，提升社区活跃度和成员归属感。",
    foEcosystemDevelopmentLeadResp5: "开发科学的生态系统价值评估模型，持续跟踪关键绩效指标，推动运营策略的迭代改进，确保生态系统的长期活力和价值增长。",
    foEcosystemDevelopmentLeadQualifications: "资格要求:",
    foEcosystemDevelopmentLeadQual1: "全日制本科及以上学历。海外知名院校研究生学历优先。要求仪表专业，英语工作熟练。",
    foEcosystemDevelopmentLeadQual2: "最少5年高端金融社区运营、金融机构战略合作或为首席财务官群体提供深度服务的经验。有从零到一成功构建首席财务官社区的经验优先。",
    foEcosystemDevelopmentLeadQual3: "出色的内容策划和专业文案写作能力，能够准确识别首席财务官的核心问题并开发有影响力的传播材料。",
    foEcosystemDevelopmentLeadQual4: "深入了解上市公司治理、资本市场运作和首席财务官专业场景，能够在他们的沟通语境中有效互动。需要具备首席财务官层面的网络资源。",
    foEcosystemDevelopmentLeadQual5: "出色的战略思维和资源整合能力，具备独立推动复杂项目完成并实现可持续生态系统价值转换的能力。",

    // Channel Development Manager (Hong Kong  CFO Ecosystem Focus) 职位详情
    channelDevelopmentManagerHongKongJobResponsibilities: "工作职责:",
    channelDevelopmentManagerHongKongResp1: "开发并维护与上市公司、拟上市公司和基金管理公司首席财务官密切相关的关键渠道合作伙伴的战略合作关系，包括但不限于证券公司、投资银行、律师事务所、会计师事务所以及行业协会。",
    channelDevelopmentManagerHongKongResp2: "独立或联合组织各种线上线下活动，如行业论坛、闭门研讨会和专业沙龙，提升公司在首席财务官社区中的专业影响力。",
    channelDevelopmentManagerHongKongResp3: "准确触达目标首席财务官客户群体，促进客户资源的有效转化，并持续深化客户关系以实现长期价值创造。",
    channelDevelopmentManagerHongKongQualifications: "资格要求:",
    channelDevelopmentManagerHongKongQual1: "全日制本科及以上学历，海外知名院校毕业生优先；仪表专业，普通话沟通流利，能深入融入首席财务官圈子并建立有效对话。",
    channelDevelopmentManagerHongKongQual2: "至少2年证券投资银行业务、律师事务所、专业服务或高端渠道合作经验，拥有成熟的机构网络和稳固的客户关系。",
    channelDevelopmentManagerHongKongQual3: "擅长渠道谈判和联合活动策划，具备出色资源整合和项目执行能力。",
    channelDevelopmentManagerHongKongQual4: "熟悉首席财务官社区的沟通场景和业务重点领域，能够准确识别核心需求并建立信任关系。",

    // HR Manager (Talent Acquisition Focus) 职位详情
    hrManagerJobResponsibilities: "工作职责:",
    hrManagerResp1: "领导香港、新加坡和美国市场的端到端招聘流程，确保关键职位的及时入职，同时支持中国大陆的招聘需求。",
    hrManagerResp2: "建立和优化招聘标准和流程，利用LinkedIn和其他国际平台多元化招聘渠道，提高招聘效率和质量。",
    hrManagerResp3: "为业务部门提供专业的招聘咨询和人才评估建议，并支持香港办事处的日常办公运营和重要客户活动。",
    hrManagerQualificationsRequirements: "资格要求:",
    hrManagerQual1: "全日制本科及以上学历，海外知名院校毕业生优先；仪表专业，普通话沟通流利。",
    hrManagerQual2: "最少5年招聘经验，有保险经纪/金融服务背景或在港、新、美市场多地区招聘成功经验者优先。",
    hrManagerQual3: "精通LinkedIn和其他国际招聘平台，具备优秀的中英文沟通技巧和跨文化协作能力。",
    hrManagerQual4: "能在快节奏环境中同时管理多个招聘项目。",

    // Head of Singapore Branch 职位详情
    headOfSingaporeBranchJobResponsibilities: "工作职责:",
    headOfSingaporeBranchResp1: "监督新加坡保险经纪实体的设立和注册，确保完全符合当地监管要求。",
    headOfSingaporeBranchResp2: "开发并维护与保险公司的合作伙伴关系，处理日常业务咨询并谈判合作协议。",
    headOfSingaporeBranchResp3: "主导定制化保险解决方案的设计和客户报价流程，管理保单续保、理赔协调和客户关系维护。",
    headOfSingaporeBranchResp4: "支持市场推广活动的策划和执行，提升公司在当地市场的品牌影响力。",
    headOfSingaporeBranchResp5: "管理新加坡分公司的日常运营和行政事务。",
    headOfSingaporeBranchQualifications: "资格要求:",
    headOfSingaporeBranchQual1: "必须事先获得新加坡金融管理局(MAS)的书面批准，才能担任指定代表。",
    headOfSingaporeBranchQual2: "完全满足MAS规定的胜任能力要求，深入了解新加坡保险监管框架。",
    headOfSingaporeBranchQual3: "拥有丰富的保险行业经验和经证实的团队管理能力，具备出色的战略规划和执行技能。",
    headOfSingaporeBranchQual4: "满足MAS\"适当人选\"标准。",
    headOfSingaporeBranchQual5: "必须常驻新加坡（除非MAS明确豁免）。",
  },
  realEstateConstructions: {
    heroTitle: '房地产与建筑工程',
    contactUs: '联系我们',
    riskText: '房地产与建筑行业在从项目规划到运营维护的全生命周期中，面临各类风险。',
    preDevelopmentStage: '开发前期阶段',
    preDevelopmentDesc: '土地使用权纠纷、规划审批延误、地质勘察误差',
    constructionPhase: '建筑施工阶段',
    constructionDesc: '工期延误、质量缺陷、施工设备损坏、第三者责任',
    operationPeriod: '运营使用阶段',
    operationDesc: '自然灾害、火灾、意外事故影响房地产资产；物业设施老化、租户安全事故、租金收入损失',
    transactionLinks: '交易环节相关',
    transactionDesc: '市场波动与政策变化影响投资开发；产权瑕疵、资金链问题导致资产减值',
    specialRisks: '特殊风险',
    specialRisksDesc: '旧建筑改造中的结构风险与合规问题；大型综合体项目中的公共安全与人员聚集风险',
    fullCycleSolutions: '全周期保险解决方案',
    constructionAllRisks: '建筑工程一切险及第三者责任险',
    constructionAllRisksDesc: '核心保障范围包括：火灾、暴雨、碰撞等意外导致的主体工程、临时工程及建筑材料损失；同时承担施工期间对第三者造成的人身伤害或财产损失赔偿责任。',
    erectionAllRisks: '安装工程一切险',
    erectionAllRisksDesc: '专为机电安装项目设计，保障工业设备、管道、电力系统等安装调试期间的意外损失，包括设备本身损坏及安装过程中引发的相关损失。',
    personnelProtection: '建筑施工人员保障计划',
    personnelProtectionDesc: '整合雇主责任险与意外险，覆盖施工人员从上下班途中到工作期间的意外风险，包括身故、伤残及医疗费用，可附加职业病保障。',
    performanceGuarantee: '工程履约保证保险',
    performanceGuaranteeDesc: '替代传统保证金，保障业主因承包商违约（如停工、质量不达标、延期交付）遭受的经济损失，确保项目按合同推进。',
    rentalGuarantee: '租金保证保险',
    rentalGuaranteeDesc: '为房地产房东提供租金损失保障，覆盖租户欠租、提前退租及租赁期间房屋损坏等风险。',
    environmentalLiability: '环境责任险',
    environmentalLiabilityDesc: '保障建筑项目引发的环境污染事故，包括土壤与地下水污染清理费用及第三者索赔。',
    professionalLiability: '专业责任险',
    professionalLiabilityDesc: '为建筑师、工程师、监理等专业人员提供过失责任保障，覆盖因设计错误、监理疏漏导致的工程损失赔偿。',
    propertyManagement: '物业管理责任险',
    propertyManagementDesc: '保障物业管理公司因管理疏忽导致业主财产损失或人身伤害的赔偿责任，包括设备维护不当、安全管理疏漏等责任风险。',
    serviceAdvantages: '我们的服务优势',
    advantage1: '根据项目特点定制保险方案，平衡风险保障与成本控制。',
    advantage2: '提供全流程风险咨询，从项目评估到理赔协助全程覆盖。',
    advantage3: '整合全球再保险资源，应对大型复杂项目的高价值风险。',
    advantage4: '建立快速理赔通道，降低意外事故对项目进度的影响。',
    advantage5: '配备具备建筑工程背景的保险顾问，精准理解行业需求。'
  },
  lifeScience: {
    heroTitle: '生命科学',
    contactUs: '联系我们',
    title: '将生命科学风险转化为发展机遇',
    introText1: '在生命科学领域，每一项科学发现都承载着巨大的希望，也伴随着重大的风险。从临床试验到商业化推广，一次挫折都可能让数年努力付诸东流这。生命科学的风险形态多样——无论是生产环境的监管合规要求，还是对数字技术日益增长的依赖——任何风险都可能对行业发展产生深远影响。',
    introText2: '我们深知这些特殊挑战的存在，因此不断拓展创新解决方案的服务边界，覆盖从临床前及I-IV期试验到商业化扩大的全周期。为您量身定制保险，并能随着您研发项目的发展而灵活调整。',
    introText3: '作为专注于生命科学领域的专业保险团队，我们为各类生命科学企业提供定制化保险服务：',
    pharmaceuticals: '制药企业',
    drugDistribution: '药品流通企业',
    healthSupplements: '保健品企业',
    biotechnology: '生物技术企业',
    medicalDevices: '医疗器械企业',
    equipments: '设备厂商'
  },
  financialInstitutions: {
    heroTitle: '金融机构',
    contactUs: '联系我们',
    keyChallenges: '金融风险的核心挑战',
    economicVolatility: '经济与运营波动性',
    economicVolatilityDesc1: '地缘政治紧张、市场波动及竞争加剧，使金融机构面临更大不确定性。',
    economicVolatilityDesc2: '与此同时，数字化转型持续冲击传统商业模式，对机构的战略灵活性与运营韧性提出更高要求。',
    regulatoryComplexity: '监管与合规复杂性',
    regulatoryComplexityDesc1: '不断演变的监管框架与攀升的合规成本，要求机构建立更完善、更综合的风险治理体系。',
    regulatoryComplexityDesc2: '董事会正逐渐将诉讼与合规监管列为战略重点。',
    technologyRole: '技术的双重角色',
    technologyRoleDesc1: '创新（包括金融科技、人工智能、自动化）为增长开辟新路径，但同时也增加了网络安全风险、数据隐私风险与运营风险敞口。',
    distinctValue: '我们的特殊价值',
    tailoredSolutions: '定制化风险解决方案',
    tailoredSolutionsDesc1: '我们专注于金融与高管责任风险领域（包括董事及高级管理人员责任险、专业责任险、网络安全险），服务客户涵盖区域型机构、中小企业、跨国企业及公共机构。',
    tailoredSolutionsDesc2: '我们的定制化策略帮助机构在韧性与创新之间寻求平衡。',
    globalAccess: '全球市场网络',
    globalAccessDesc1: '依托与全球领先保险公司的合作关系，为客户提供最优保障范围且具有价格竞争力的条款。',
    holisticMitigation: '全方位风险管控',
    holisticMitigationDesc1: '采用整合式的一揽子解决方案，统筹应对财产险、责任险等传统风险，同时覆盖网络风险及ESG相关风险等新兴风险。',
    strategicPriorities: '前瞻性机构的战略重点',
    riskAgility: '提升风险敏感度',
    riskAgilityDesc: '主动识别并管理运营、人力及战略实施中的风险暴露，增强机构风险韧性。',
    safeguardingGrowth: '守护声誉与增长',
    safeguardingGrowthDesc: '将企业风险框架与长期可持续发展及治理目标对齐，保护品牌声誉，实现可持续增长。'
  },
  sportsEntertainmentEvents: {
    heroTitle: '体育、娱乐及活动',
    heroDesc: '依托体育、娱乐及活动行业的自身特点，耀达为主办方、制作方、艺人及其他相关主体提供保险与风险管理解决方案。',
    contactUs: '联系我们',
    coreServices: '我们的核心服务与产品',
    coreServicesDesc: '我们为展览场馆、组织者和参展商提供一站式、多元化的保险解决方案。保障范围包括财产损失、三方责任以及人身意外保险。',
    completionGuarantee: '完工保障保险',
    equipmentInsurance: '专业设备保险',
    professionalLiability: '专业责任险',
    eventCancellation: '活动取消保险',
    personnelInsurance: '人员保险',
    defamationInsurance: '诽谤责任险',
    competitiveAdvantages: '我们的竞争优势',
    industryExpertise: '深厚的行业专业知识',
    clientPortfolio: '广泛的客户群体',
    globalCapacity: '全球承保能力'
  },
  energyPower: {
    heroTitle: '能源与电力',
    contactUs: '联系我们',
    challengesTitle: '能源行业的挑战与机遇',
    growingDemand: '需求增长与脱碳转型',
    growingDemandDesc1: '全球能源需求持续上升，但脱碳压力正重塑行业格局。',
    growingDemandDesc2: '企业面临政策变动、技术变革与气候风险带来的不确定性。',
    keyRisks: '核心风险因素',
    risk1: '合规成本（如碳定价、排放标准）',
    risk2: '实体与转型气候风险（如极端天气、以及因能源转型而价值受损或被提前淘汰的搁浅资产）',
    risk3: '责任（如污染、供应链中断）',
    strategicValue: '为客户创造的战略价值',
    resilienceTitle: '转型韧性与适应',
    resilienceDesc: '在推进脱碳的同时保障运营稳定。',
    advantageTitle: '竞争优势',
    advantageDesc: '依托绿色金融与ESG对齐解决方案。',
    futureTitle: '未来增长',
    futureDesc: '把握可再生能源、氢能与循环经济领域的机遇。',
    riskSolutions: '风险解决方案',
    greenProducts: '绿色保险产品',
    greenProductsDesc1: '碳捕集利用与封存（CCUS）保险，脱碳项目的技术与财务风险。',
    greenProductsDesc2: '环境污染责任保险，覆盖合规与清理成本。',
    greenProductsDesc3: '气候风险分析工具，助力评估并适应实体/转型风险。',
    integratedRisk: '整体风险管理',
    integratedRiskDesc1: '融合“技术”（如用于风险监控的物联网）、“资本”（如风险转移结构）与“保险”，提供端到端保障。',
    integratedRiskDesc2: '通过动态风险定价与定制化保障，优化成本。',
    callToAction: '行动号召',
    actionText: '与我们合作，打造具备风险韧性的能源业务，将转型挑战转化为可持续增长动力。'
  },
  manufacturingTechnology: {
    manufacturingHeroTitle: '制造业',
    manufacturingHeroDesc: '我们依托行业洞察与专业风险管理解决方案，帮助您精准识别、评估并转移关键风险暴露。我们的目标是增强您的运营韧性，守护您实现持续盈利与增长的保驾护航。',
    contactUs: '联系我们',
    whatWeDo: '我们能提供什么？',
    whatWeDoDesc: '耀达提供整合式风险解决方案，连接保险保障与主动风险管理。',
    riskExposure: '风险敞口图谱',
    riskExposureDesc: '依托市场领先的分析工具，识别运营盲区',
    endToEnd: '端到端风险缓释',
    endToEndDesc: '覆盖实物资产损坏、业务中断、产品责任及新兴网络威胁',
    sustainableGrowth: '可持续增长保障',
    sustainableGrowthDesc: '将气候适应与ESG治理融入保障框架',
    whatWeDoDesc2: '凭借行业专属专业知识与前沿风险技术，我们的专家团队帮助您降低总风险成本，稳定运营波动，让您能专注于核心业务。',
    technologyHeroTitle: '科技行业',
    technologyHeroDesc: '创新之路充满未知风险。耀达凭借前瞻性视野与全面保障，为您抵御不确定性。',
    whatWeSupport: '我们支持哪些领域？',
    supportDesc1: '我们深刻理解科技领域的独特风险特征——从数据安全与隐私保护、知识产权纠纷、研发中断，到供应链脆弱性及新兴技术应用带来的未知挑战。',
    supportDesc2: '依托专业行业洞察、先进风险建模工具与定制化解决方案，我们帮助科技企业构建坚实的风险防护网络，同时加速创新步伐。',
    supportDesc3: '无论是初创科技公司还是成熟科技巨头，耀达都能提供涵盖财产保障、责任险、网络安全保障等的全面保险产品与风险管理服务，让您在数字浪潮中安心前行，专注于核心技术突破与商业价值创造。'
  },
  foodBeverage: {
    heroTitle: '食品与饮料',
    contactUs: '联系我们',
    growingRiskChallenges: '日益增长的风险挑战',
    operationalRisks: '运营与环境风险',
    operationalRisk1: '气候变化与极端天气导致的原材料短缺',
    operationalRisk2: '更严格的全球监管（如食品安全、碳排放、限塑政策）',
    cyberRisks: '网络与地缘政治风险',
    cyberRisk1: "数据泄露与网络攻击威胁运营,数据泄露与网络攻击对业务运营构成威胁",
    cyberRisk2: '地缘政治紧张与能源成本波动扰乱供应链',
    riskSolutions: '我们的风险管理解决方案',
    tailoredProtection: '全价值链定制化保障',
    tailoredProtection1: '覆盖制造商、加工商、分销商及餐饮服务提供商',
    tailoredProtection2: '应对产品责任、供应链中断、召回风险的解决方案',
    futureProof: '面向未来的风险策略',
    futureProof1: '合规支持（如食品安全、ESG报告）',
    futureProof2: '网络保险与数字威胁危机管理',
    futureProof3: "气候相关中断的参数保险,气候相关干扰的参数化保险",
    sustainableGrowth: '推动可持续增长',
    sustainableGrowth1: "与行业趋势对齐的风险预防与缓释,与行业趋势相契合的风险防范与缓释",
    sustainableGrowth2: '高成本效益的风险转移，提升业务韧性'
  },
  privateEquity: {
    heroTitle: '私募股权与风险投资',
    heroDesc: '我们始终助力客户在充满不确定性的市场环境中稳健前行，应对募资、投资策略与退出规划等领域的复杂挑战，并把握监管政策更新所带来的行业变局。',
    contactUs: '联系我们',
    whatDoesItCover: '保障范围包括哪些？',
    directorsOfficers: '董事及高级管理人员责任险',
    directorsOfficersDesc: '保障代表普通合伙人、基金、投资管理人及其关联实体行事的董事、高级管理人员或员工，使其免于因被指控存在管理不当、误导性陈述、违反受信义务等行为而产生的相关索赔风险。',
    outsideDirectorship: '外部董事责任险',
    outsideDirectorshipDesc: '承保董事、高级管理人员（或同等职位人员）在投资组合公司中以其指定身份行事时，因不当行为而引发的相关索赔。',
    professionalIndemnity: '专业责任险',
    professionalIndemnityDesc: '承保私募股权公司、基金及其普通合伙人、董事、高级管理人员和员工因提供或未提供专业服务（投资咨询服务）过程中存在过失与疏忽，而被投资者、投资组合公司及其股东和管理层提出的相关索赔。',
    crime: '犯罪保险',
    crimeDesc: '保障公司或基金免于因员工及 / 或第三方实施的任何不诚实、欺诈或恶意行为而遭受的直接经济损失。',
    commonRiskScenarios: '常见风险场景',
    liquidityRisk: '流动性风险',
    operationalRisk: '运营与整合风险',
    moralRisk: '道德风险',
    geopoliticalRisk: '地缘政治风险',
    financialRisk: '财务与估值风险',
    legalRisk: '法律与合规风险',
    ourCommitment: '您的资本，我们的承诺',
    ourCommitmentDesc: '',
    ventureClients: '私募股权与风险投资客户',
    industryExpertise: '多年行业经验',
    fundsServed: '累计服务的美元基金与人民币基金数量',
    insuredVolume: '累计承保基金规模',
    additionalServices: '附加服务',
    additionalServicesDesc1: '依托强大的行业高管网络，帮助企业解决运营难题，释放增长潜力。',
    additionalServicesDesc2: '通过精心策划的行业活动与高管论坛，构建动态知识交流平台，让客户始终走在战略创新前沿。',
    riskFundraising: '募集资金',
    riskFundraisingItem1: '1. 不恰当的投资建议',
    riskInvestment: '投资',
    riskInvestmentItem1: '1. 未尽到勤勉尽职的疏忽行为',
    riskInvestmentItem2: '2. 与其他投资者存在竞争',
    riskInvestmentItem3: '3. 未经授权使用非公开信息',
    riskManagement: '投资管理',
    riskManagementItem1: '1. 为被投公司提供专业服务的相关责任',
    riskManagementItem2: '2. 雇用或解雇主要管理人员的相关责任',
    riskManagementItem3: '3. 外部董事责任',
    riskExitPlan: '退出投资',
    riskExitPlanItem1: '1. 被投企业破产',
    riskExitPlanItem2: '2. 与被投公司内部信息相关的责任',
    riskExitPlanItem3: '3. 招股说明书存在不实陈述'
  },
  mergersAcquisitions: {
    heroTitle: '并购交易',
    heroDesc: '任何的交易都可能包含不确定因素，并购保证及补偿保险(W&I)作为一种有效的工具，能够在促进交易双方谈判进程时，有效转移潜在风险。',
    contactUs: '联系我们',
    structureTitle: 'W&I保险结构',
    sellerPerspective: '卖方视角',
    sellerInsured: '被保险人：',
    sellerInsuredDesc: '作为保证方的卖方。',
    sellerObjective: '目标：',
    sellerObjectiveDesc: '当买方因卖方违反保证条款或赔偿条款（如未披露负债）提出索赔时，为卖方提供保障。',
    sellerPolicy: '保单结构：',
    sellerPolicyDesc: '保障限额与合同约定的最大责任限额一致。',
    sellerCompensation: '赔偿机制：',
    sellerCompensationDesc: '卖方仍需承担合同约定的义务，并覆盖保单未赔付的违约损失。',
    buyerPerspective: '买方视角',
    buyerInsured: '被保险人：',
    buyerInsuredDesc: '买方。',
    buyerObjective: '目标：',
    buyerObjectiveDesc: '覆盖因卖方违反保证条款（如财务报表不准确）导致的买方经济损失。',
    buyerPolicy: '保单结构：',
    buyerPolicyDesc: '卖方保证的责任限额较低，保单覆盖超额部分。',
    buyerClaim: '索赔流程（第一方保单）：',
    buyerClaimDesc: '独立于卖方，买方可直接向保险公司索赔。',
    ourRole: '我们的角色：您可靠的专业合作伙伴',
    ourRoleDesc1: '作为领先的独立保险服务商，我们专注于交易风险解决方案，为并购交易的独特需求提供全面咨询与投保服务。',
    ourRoleDesc2: '我们的团队由资深专业人士组成，兼具深厚的承保专业承保知识与对交易动态的透彻理解，帮助客户缓释风险，保障交易结果。',
    strategicTitle: '我们专注于并购交易风险管理，为各类交易的特殊需求提供专业的保险方案与全程咨询服务。我们的团队汇聚了资深专业人士，既具备扎实的保险经验又对并购交易动态有着敏锐洞察，致力于帮助客户有效缓释风险，保障交易顺利达成。',
    strategicDesc1: '对目标公司、交易结构及基础收购协议进行全面初步分析。',
    strategicDesc2: '识别核心风险敞口，并就最优保单架构如（买方保单、卖方保单）提供专业建议，以精准匹配客户目标。',
    strategicDesc3: '就免赔额、保单限额及保障范围提供指导，在最大化保障的同时优化保费成本。',
    marketAccess: '市场接入与方案沟通',
    marketDesc1: '依托建立起的全球保险网络。',
    marketDesc2: '谈判保单条款、除外责任与条件，获取最有利的保障条款，最大程度减少保障缺口与歧义。',
    claimsTitle: '索赔支持与交易后服务',
    claimsDesc1: '代表客户利益，确保索赔得到公平、高效处理。',
    claimsDesc2: '就交易完成后的新兴风险提供咨询，避免意外情况。',
    claimsDesc3: '与保险公司协调，快速解决索赔，保障交易价值。'
  },
  propertyCasualty: {
    heroTitle: '财产与意外险',
    heroDesc: '守护核心资产，从容应对不确定的未来。在耀达，我们不采用“通用型”保单，而是坚持以企业发展阶段和行业特性为出发点，打造随业务成长而演进的保险方案，切实保障企业与团队成员。',
    contactUs: '联系我们',
    tailoredSolutions: '定制化财产与意外险解决方案',
    commercialProperty: '商业财产险',
    commercialPropertyDesc: '覆盖火灾、洪水、盗窃等风险，全面保障支撑企业运营的场所与核心资产。',
    generalLiability: "商业综合责任险(CGL)",
    generalLiabilityDesc: '当意外事件发生时，帮助您专注于持续运营，而非应对复杂的法律责任。',
    productLiability: '产品责任险',
    productLiabilityDesc: '出色的产品值得全面的保障——尤其是在意外发生时。',
    commercialAuto: '商业汽车保险',
    commercialAutoDesc: '无论车队规模大小，均可为企业用车风险提供保障，确保您的业务持续运转。',
    workersComp: '工伤赔偿保险',
    workersCompDesc: '员工是企业最宝贵的资产。此保险在员工发生工伤时提供妥善保障，同时协助企业持续满足合规要求。',
    globalLandscape: '全球布局',
    globalDesc: '我们专注于支持企业的跨境发展。依托在美国及亚太市场的专业经验，协助您构建既符合当地监管要求、又与全球战略高度一致的风险管理体系。'
  },
  cyberSecurity: {
    heroTitle: '网络安全',
    heroDesc: '随着全球数据保护法规日益严格，企业必须建立完善的数据治理框架，以应对不断提升的合规要求。网络保险不仅是风险转移工具，更是协助企业应对复杂数字威胁的战略解决方案。',
    contactUs: '联系我们',
    commonSources: '网络风险的常见来源',
    phishing: '钓鱼攻击',
    phishingDesc: '钓鱼攻击是社会工程学的一种形式，攻击者发送包含恶意链接或附件的欺诈性邮件或信息，诱骗用户泄露敏感信息或安装恶意软件。',
    networkWeaknesses: '网络安全漏洞',
    networkWeaknessesDesc: '未打补丁的软件、过时的协议或配置错误的防火墙等网络漏洞，可能被攻击者利用以非法访问系统。',
    spam: '垃圾邮件',
    spamDesc: '垃圾邮件指未经请求的信息，通常包含钓鱼链接或恶意软件，用户一旦交互即面临重大安全风险。',
    malware: '恶意代码（恶意软件）',
    malwareDesc: '恶意软件（包括勒索软件、间谍软件）指旨在干扰运营、窃取数据或破坏系统的恶意程序。',
    cyberCrime: '网络犯罪',
    cyberCrimeDesc: '网络犯罪涵盖黑客攻击、身份盗窃、网络欺诈等非法数字活动，通常以获取经济利益或扰乱运营为目的。',
    unauthorizedAccess: '未授权系统访问',
    unauthorizedAccessDesc: '未授权系统访问指入侵者绕过安全控制，窃取数据、扰乱运营或发起进一步攻击的行为。',
    whatDoesItCover: '保障范围包括哪些？',
    firstParty: '第一方责任保障',
    incidentResponse: '事件响应',
    incidentResponseItems: [
      '降低网络事件成本',
      '法律咨询',
      '应急响应管理',
      '公关公司服务',
      '计算机取证',
      '通知/呼叫中心服务'
    ],
    businessInterruption: '业务中断',
    businessInterruptionDesc: '保障因业务中断导致的净利润损失、持续运营费用及员工薪资支出。',
    cyberExtortion: '网络勒索',
    cyberExtortionDesc: '为终止网络勒索事件而支付的款项（需符合承保的法律许可条件），以及聘请第三方顾问进行谈判与支付的费用。',
    dataRestoration: '数据与系统恢复',
    dataRestorationDesc: '因业务中断导致的数据损坏、丢失的恢复费用，系统恢复费用，以及其他与恢复业务运营能力的相关费用。',
    thirdParty: '第三方责任保障',
    privacyLiability: '隐私与网络安全责任',
    privacyLiabilityDesc: '因以下情形产生的辩护费用与损害赔偿：',
    privacyLiabilityItems: [
      '未能充分保护个人数据安全',
      '未能保护第三方非公开商业信息的机密性',
      '未能防范与控制恶意行为的网络安全缺陷'
    ],
    mediaLiability: '媒体责任',
    mediaLiabilityDesc: '因在线媒体服务中的不当行为（如诽谤、窃听、侵犯隐私、版权侵权）引发索赔的辩护费用与损害赔偿。',
    whyChoose: '为何选择耀达？',
    whyChooseDesc: '作为专业风险解决顾问，我们依托先进分析工具评估您公司的网络风险暴露，制定数据驱动的保险战略。',
    experienceLed: '经验导向的保险咨询',
    experienceLedDesc: '凭借为私募股权与风险投资公司服务的丰富经验，我们融合技术专业知识与实际理赔能力，提供受高端客户信赖的优质咨询服务。',
    aiDriven: '人工智能驱动的评估',
    aiDrivenDesc: '通过一套全面的人工智能工具与问卷，帮助企业系统识别网络安全风险，制定定制化保障方案，守护核心资产。',
    fullCycle: '独特的全周期流程',
    fullCycleDesc: '我们的全周期方案涵盖风险识别、风险缓释、保单协调与快速事件响应。依托精心筛选的顶级网络服务提供商网络，我们确保快速高效地解决问题。'
  },
  globalClients: {
    heroTitle: '全球客户',
    heroDesc: '本地洞察 · 全球视野 · 定制保障',
    contactUs: '联系我们',
    introText1: '在跨境经营背景下，风险管理已成为前瞻性企业面临的核心挑战之一。随着企业持续拓展国际市场，保险早已不再是合规层面的必需品，而是上升为一项战略资产—用于保障运营稳健、实现监管协调，并增强各利益相关方的信心无论是高速成长的初创企业、已上市公司，还是在多个司法管辖区和市场快速扩张的区域性企业，对清晰、灵活且具备本地洞察的保险战略的需求，正以前所未有的速度上升。',
    introText2: '这正是耀达的优势所在。我们帮助企业化繁为简，弥合监管差异，守护企业最核心的资产——让您能够专注于业务增长，稳健前行。',
    introText3: '无论您是进军北美的中国企业、在亚洲招聘的美国初创公司，还是在全球多地运营的跨国集团，我们都理解跨境扩张所带来的挑战，并致力于为您提供更全面的保障。',
    introText4: '我们的团队深谙北美、大中华区和东南亚的风险环境，并在美国、中国大陆以及香港子公司持有合法牌照。我们不止于安排保险交易，而是为全球客户构建兼具灵活性、合规性与可扩展性的企业级保险战略。',
    supportTitle: '我们为客户提供支持，包括：',
    supportItem1: '设计覆盖多个国家与符合监管框架的保险方案',
    supportItem2: '管理全球供应链中的责任、财产及雇员风险',
    supportItem3: '为跨境交易、境外资产及国际合同提供全面保障',
    supportItem4: '确保保险安排持续契合不断演进的法律、监管及运营需求',
    closingText: '选择耀达，您将获得一位真正理解您业务布局、发展路径与核心风险的风险顾问。面向全球发展的愿景，理应匹配全球化的保险保障——让我们携手共建。',
    ourExpertise: '我们的专业能力',
    expertiseDesc: '我们的专属全球团队拥有深厚的行业经验，能够前瞻性识别风险、制定定制化解决方案，并高效整合全球保险市场资源，为客户创造可量化的实际价值。',
    experienceYears: '年',
    experienceYearsDesc: '服务团队核心成员在董事及高级管理人员保险（D&O）领域平均拥有10年以上的专业经验。',
    insurancePartners: '家保险<br/>公司',
    insurancePartnersDesc: '耀达与30余家国内外保险公司建立了稳固的合作关系，能够为客户争取更具竞争力的保障条款与价格。',
    clientsServed: '家客户',
    clientsServedDesc: '团队在董事及高级管理人员责任险领域累计保费超过1000万美元，服务机构客户超200家。'
  },
  directorsOfficers: {
    heroTitle: '董事及高级管理人员\n责任保险',
    heroDesc: '随着全球市场对公司治理关注度不断提升，董事及高级管理人员（D&O）保险成为防范董事个人责任的重要保障。它帮助企业应对监管挑战与市场波动，增强管理层信心，支持长期价值创造。',
    contactUs: '联系我们',
    whatDoesItCover: 'D&O保险保障范围包括哪些？',
    keyCoverage: '核心保障',
    sideAPersonalProtection: 'Side A - 个人保障',
    sideAPersonalProtectionDesc: '在公司无法赔偿董事/高管时（如破产、法律限制），直接为其提供保障。',
    sideBCorporateReimbursement: 'Side B - 公司补偿',
    sideBCorporateReimbursementDesc: '补偿公司已向董事/高管支付的赔偿费用。',
    sideCEntityCoverage: 'Side C - 实体保障',
    sideCEntityCoverageDesc: '为公司本身提供保障，聚焦于证券相关索赔。',
    extendedProtections: '扩展保障:',
    regulatoryInvestigations: '监管调查的辩护费用。',
    mismanagementFiduciaryBreach: '指控虚假陈述或误导性信息的股东诉讼。',
    shareholderSecuritiesLitigation: '与雇佣相关的管理责任（如不当解雇索赔）。',
    prospectusIPOExposures: '指控违反信义义务或公司管理不当的索赔。',
    employmentRelatedLiability: '首次公开发行（IPO）前后因招股书与披露文件引发的责任。',


    whoIsProtected: '保障对象',
    insuredPerson: '被保障个人',
    currentDirectors: '现任、前任及未来的董事、监事与高级管理人员。',
    deFactoDirectors: '事实董事/影子董事(在法律认可的情况下)。',
    managerialEmployees: '具有管理职能的员工。',
    blanketOutsideDirectorship: '可扩展外部董事。',
    insuredEntity: '被保障实体',
    theCompany: '公司本身(在适用公司实体责任保险的情况下)。',
    majorityOwnedSubsidiaries: '持股超过半数的子公司。',
    newlyAcquiredSubsidiaries: '在保单约定范围内新收购或新设立的子公司。',
    notForProfitEntities: '符合条件的非营利组织(如列入承保范围)。',
    actualCoverage: '实际保障范围以保单载明的具体条款和条件为准，本页面/本资料内容仅供参考。',
    commonRiskScenarios: '常见风险场景',
    employeeAllegations: '员工对歧视或不当解雇的指控',
    shareholderDerivativeActions: '股东派生诉讼',
    securitiesMisstatements: '因财务虚假陈述或延迟披露引发的证券诉讼',
    regulatoryInvestigationsInitiated: '监管机构发起的调查',
    corporateRegulatoryObligations: '声称违反公司、监管或治理义务的索赔',
    ourExpertise: '我们的专业能力',
    expertiseDesc: '我们的全球DO专业团队拥有深厚的行业专属知识与前瞻性的风险洞察能力，能够基于您的业务需求据供定制化解决方案，并战略性对接全球保险市场资源，为您的业务创造可衡量的实际价值。',
    yearsOfExperience: '10+',
    yearsLabel: '年',
    experiencePerTeamMember: '我们的核心服务团队在D&O领域平均拥有超十年的经验。',
    globalInsurers: '30+',
    globalInsurersLabel: '家',
    securingOptimalTerms: '覆盖30余家全球保险人网络，可在全球范围内争取最优条款与费率。',
    clientsServed: '200+',
    clientsServedLabel: '客户',
    cumulativePremium: '服务200余家客户，累计已安排D&O保费超过1,000万美元。',
    whyChoose: '为什么选择耀达？',
    deepMarketExpertise: '深耕本地市场',
    deepMarketExpertiseDesc: '依托多地区本地化服务，确保方案设计兼顾属地监管要求与跨境风险管理，实现高效落地与协同。',
    tailoredRiskSolutions: '量身定制的风险解决方案',
    tailoredRiskSolutionsDesc: '我们构建量身定制的保险计划，解决多司法管辖区运营、不断发展的商业模式和复杂的集团结构问题。',
    regulatoryComplianceInsight: '合规监管洞察',
    regulatoryComplianceInsightDesc: '结合对全球监管要求的把握，协助确保跨境安排符合法规并降低合规成本。'
  },
  employeeBenefits: {
    heroTitle: '员工福利团体保险经纪',
    heroDesc: '为企业与员工搭建安心保障桥梁',
    contactUs: '联系我们',
    coreServices: '核心服务',
    customizedSolutions: '定制化团体保险经纪服务',
    inDepthAssessment: '结合内外部信息，助您深度评估需求',
    assessmentDesc: '准确定位企业成本管控目标与员工风险管理需求的最佳平衡点',
    corporateInterviews: '企业访谈',
    employeeSurveys: '员工调研',
    industryTrends: '市场与政策趋势',
    financialBudgets: '财务预算',
    comprehensiveProtection: '越全面的保障体系，越需要灵活的方案设计',
    protectionDesc: '多种主流保险产品可灵活定制，既有扎实的默认基础计划，也有丰富的自选升级计划。',
    healthMedical: '健康医疗',
    healthMedicalDesc: '全面的健康医疗保障应兼顾员工身心健康，包括门急诊、住院、牙科、眼科、体检服务等。',
    riskProtection: '风险保障',
    riskProtectionDesc: '多元化的风险保险组合涵盖团体人寿保险、意外身故及伤残保险、长期失能保险以及重大疾病保险，为员工的职业生涯与个人生活提供全面保障。',
    retirementPlanning: '养老规划',
    retirementPlanningDesc: '一份优质的企业养老金计划可包含灵活定制的缴费比例、多渠道的投资选项，以及退休后医疗补贴，从而帮助员工实现安稳的退休生活。',
    dynamicOptimization: '动态优化调整',
    dynamicDesc: '建立',
    and: '与',
    quarterlyReview: '季度数据复盘',
    quarterlyReviewDesc: '每季度分析福利使用数据（如赔付率、员工偏好、保障缺口），为年度调整提供依据。',
    annualIteration: '年度方案迭代',
    annualIterationDesc: '结合国家医保政策、税收优惠及企业发展阶段，确保福利方案始终贴合需求、实用性强且真正惠及员工。',
    mechanismText: '机制。',
    digitalPlatform: '数字化福利管理平台',
    platformDesc: '依托前沿技术，为客户提供专属企业福利保险云平台，解决企业福利管理效率低、员工福利信息获取难的核心痛点：',
    digitalPlatformCorporateTitle: '企业端：福利管理枢纽',
    digitalPlatformCorporatePoint1: '支持企业在线办理员工参保与退保，提高管理效率。',
    digitalPlatformCorporatePoint2: '生成福利使用报告与赔付率报告，为福利决策提供数据支撑。',
    digitalPlatformCorporatePoint3: '提供可视化仪表盘，清晰呈现福利投资回报（ROBI），助力成本管理。',
    digitalPlatformEmployeeTitle: '员工端：用户服务门户',
    digitalPlatformEmployeePoint1: '支持移动端（微信小程序）与PC访问',
    digitalPlatformEmployeePoint2: '员工可即时查看保障详情、理赔进度与保单信息，并一键下载电子凭证。',
    digitalPlatformEmployeePoint3: 'AI福利助手「DaDa」7×24小时在线，支持语音或文本快速答疑。',
    corporatePortal: '企业端：福利管理中心',
    corporatePortalItems: [
      '支持企业在线办理员工参保与退保，提高管理效率。',
      '生成福利使用报告与赔付率报告，为福利决策提供数据支撑。',
      '提供可视化仪表盘，清晰呈现福利投资回报（ROBI），助力成本管理。',
    ],
    employeePortal: '员工端：用户服务平台',
    employeePortalItems: [
      '支持移动端（微信小程序）与PC访问',
      '员工可即时查看保障详情、理赔进度与保单信息，并一键下载电子凭证。',
      'AI福利助手「DaDa」7×24小时在线，支持语音或文本快速答疑。'
    ],
    aiAssistant: '人工智能福利助手“达达”支持',
    aiAssistantItems: [
      '通过语音/文字交互7×24小时解答常见问题，响应时间不足3秒。'
    ],
    employeeCommunication: '员工沟通与触达',
    communicationDesc: '越是优质的员工福利保障，越需要有效的价值传递，让福利真正能够“被感知、被认可”。我们为您定制保险福利员工沟通，提升员工对保险福利的认知度、参与度及满意度。',
    stagedPlan: '多阶段员工沟通计划',
    newHires: '新员工入职',
    newHiresDesc: '提供“福利迎新礼包”（含保险福利手册、使用指南、常见问答），并每月组织福利咨询会，帮助新员工快速了解保险福利。',
    openPeriod: '年度开窗期',
    openPeriodDesc: '通过线上/线下宣讲会，为所有员工解读年度保障方案优化，为处于不同人生阶段的员工群体提供个性化福利配置建议。',
    midYearRefreshing: '年中福利回顾',
    introduceInsuranceUsageDesc: '向员工介绍各类保险服务，引导员工高效且合理地使用福利和保险服务。',
    visualDemonstration: '价值沟通与呈现',
    annualReport: '年度员工福利报告',
    annualReportDesc: '用数据清晰展示企业年度福利投入与员工实际获得的保障价值，让企业关怀具象化。',
    withDiverseVisualTools: '多元化、可视化沟通',
    withDiverseVisualToolsDesc: '采用多种内部宣发材料，结合企业内部沟通规则及设计元素，吸引员工对保险福利的关注度，包括但不限于通知邮件，长图海报，电脑屏保，印刷材料等。',
    withFeedbackChannels: '收集员工满意度反馈',
    withFeedbackChannelsDesc: '搭建员工反馈渠道，赋能员工表达对于保险福利的认可、建议与反馈，让员工拥有话语权与参与感，针对合理反馈予以响应，形成满意度闭环管理机制。',
    withAnnualUsageReport: '年度员工福利报告',
    withAnnualUsageReportDesc: '使用数据清晰展示企业年度福利投入、保险服务表现情况、员工自选升级情况、保障价值及满意度等，让企业关怀具象化，引导员工正确使用保险福利。',
    
    feedbackLoop: '反馈闭环管理',
    feedbackDesc1: '协助搭建员工反馈渠道（如平台意见箱、季度线上调研）。',
    feedbackDesc2: '及时收集建议与需求，结合可行性调整方案，让员工拥有话语权与参与感。',
    satisfactionFeedbackChannels: '设置员工满意度反馈渠道',
    collectRecognitionsSuggestionsDesc: '我们收集表扬、建议与负面反馈，赋能员工拥有话语权与参与感。',
    whyChoose: '为什么选择耀达?',
    expertTeam: '全球化服务能力',
    expertTeamDesc: '依托多地区本地化服务，确保方案设计兼顾属地监管要求与跨境风险管理，实现高效落地与协同。',
    clientRepresentation: '量身定制的风险解决方案',
    clientRepresentationDesc: '我们构建量身定制的保险计划，解决多司法管辖区运营、不断发展的商业模式和复杂的集团结构问题。',
    comprehensiveProtectionTitle: '合规监管洞察',
    comprehensiveProtectionDesc: '结合对全球监管要求的把握，协助确保跨境安排符合法规并降低合规成本。',
    endToEndService: '全流程服务，专业理赔',
    endToEndServiceDesc: '耀达提供从方案设计、投保参保到理赔的一站式服务；发生理赔时，提供专业建议与全流程协助，解决企业理赔难题。'
  },
  mainContent: {
    SeeAll: '查看所有',
    // Hero Section
    heroTitle: '智联客户  创见价值 <br>AI驱动保险经纪新纪元',
    heroSubtitle: '超越你的期望',
    contactUs: '联系我们',

    // Industries and Services
    industriesServices: '行业与服务',
    ourServices: '行业',
    services1: '服务',
    servicesDescription: '为跨行业客户定制保险方案',
    servicesDescription2: '为企业客户提供多险种解决方案',

    // Industry Cards
    automotive: '汽车行业',
    realEstateConstruction: '房地产与建筑',
    lifeScience: '生命科学',
    financialInstitutions: '金融机构',
    sportsEvents: '体育与活动',
    energyPower: '能源与电力',
    manufacturingTechnology: '制造与科技',
    foodBeverage: '食品与饮料',
    privateEquity: '私募股权与风险投资',
    mergersAcquisitions: '并购业务',
    propertyCasualty: '财产与意外保险',
    cyberSecurity: '网络安全',
    globalClients: '全球客户',

    services: {
      doManagementLiabilities: {
        title: '董事及高级职员责任保险',
        description: '保护董事和高级职员免受诉讼、财务风险和其他责任'
      },
      mergersAcquisitions: {
        title: '并购保证及补偿保险',
        description: '提供见解以促进并购交易并帮助您取得成功'
      },
      cyberSecurities: {
        title: '网络安全保险',
        description: '评估您的网络风险敞口并获得最佳违约保障'
      },
      employeeBenefits: {
        title: '员工福利',
        description: '优化福利套餐以提高招聘效率和员工留存率'
      },
      globalClients: {
        title: '全球客户',
        description: '保护您的宝贵资产以传承给后代'
      },
      propertyCasualty: {
        title: '财产和意外保险',
        description: '将风险管理融入您的核心业务战略'
      }
    },

    more: '了解更多',
    leveragingAi: '利用人工智能提高客户满意度',
    leveragingAiDesc: '耀达开发人工智能来解锁客户洞察，并使我们的团队能够专注于高价值战略。',
    leveragingOurAi: '了解更多关于我们的AI',

    Numbers: '数据洞察',
    NumbersDescription: '数字说明了一切。以领先的市场份额与持续增长的客户群为驱动，我们铸就了持久共赢的伙伴关系。',

    // Numbers Section
    yearsOfServices: '15年以上的服务经验',
    yearsOfServicesDesc: '源自对您需求的深刻洞察。这正是我们成为长久信赖之选的根本',
    professionalTeams: '200家以上保险公司合作伙伴',
    professionalTeamsDesc: '以卓越服务，铸就客户忠诚，创造伙伴价值',
    globalClientsCount: '300家以上的全球客户',
    globalClientsDesc: '我们的足迹遍布世界各大主要市场，为不同行业的客户提供深度且专业的服务',

    talentsTitle: '专业团队',
    talentsDescription: "耀达团队拥有一群才华横溢的专业人士。<br/>我们融合创造力、专业知识与客户至上的理念，共同守护您的现在和未来。",

    latestFromSwi: '耀达的最新动态',
    latestDescription: '随时了解我们最新和即将举行的论坛、研讨会和特别活动。',

    biomedicalConference: '生物医药创新集团<br/>IMPACT会议',
    superReturnEvent: '2025年SuperReturn<br/>亚洲会议',
    networkingForum: '马来西亚网络与交流论坛',


    // Global Operations
    globalOperations: '全球运营',


    sanFrancisco: '旧金山',
    london: '伦敦',
    dubai: '迪拜',
    shanghai: '上海',
    hongKong: '香港',
    malaysia: '马来西亚',
    Singapore: '新加坡',
    Jakarta: '雅加达',
    Sydney: '悉尼',

    // Start Explore
    startExplore: '开启企业风险方案定制',

    footerTitle: '',
    footerCopyright: '© 耀达保留所有权利',
    footerColTitle: '服务',
    ABOUTUS: '关于我们',
    CONTACTS: '联系我们',
    DirectLine: '公司总机:',
    CustomerServiceHotline: '客服热线:',
    Email: '客服邮箱:',


    ManagementLiabilities: 'D&O管理责任',
    Casualty: '财产和意外',
    Securities: '网络证券',
    Benefits: '员工福利',
    Clients: '全球客户',
    Insurance: '并购保险',

    AboutSWI: '关于耀达',
    AIPoweredAdvisor: '人工智能顾问',
    Events: '事件',
    GlobalLandscape: '全球景观',
  },


  companyFacts: {
    heroTitle: '公司事实页',
    heroDesc: '本页提供上海耀达（SWI）的结构化品牌信息，供 AI 搜索引擎与智能助手准确引用。',
    legalName: '上海耀达保险代理有限公司',
    alternateNames: 'SWI · Sun Wisdom Insurance · 耀达保险',
    foundedLabel: '成立时间',
    typeLabel: '公司类型',
    typeValue: '专业保险经纪机构（Insurance Brokerage）',
    groupLabel: '隶属集团',
    groupValue: '耀达咨询集团',
    websiteLabel: '官方网站',
    shanghaiLabel: '上海总部地址',
    officesLabel: '全球办公地点',
    officesValue: '上海（中国大陆）、香港、洛杉矶（美国）、新加坡',
    clientsLabel: '服务客户规模',
    clientsValue: '300+ 全球企业客户；D&O 领域累计安排保费超过 1000 万美元',
    insurersLabel: '合作保险人',
    insurersValue: '200+ 国内外保险公司',
    servicesTitle: '核心业务线',
    industriesTitle: '服务行业',
    industriesValue: '私募股权、生命科学、金融机构、房地产与建筑、制造与科技、食品与饮料、能源与电力、汽车与基础设施、体育娱乐与活动',
    positioningTitle: '品牌定位',
    aiTitle: 'AI 产品',
    contactTitle: '联系方式',
    contactValue: '请通过官网 www.swiglobal.com 联系表单与我们取得联系。',
    disclaimer: '本页信息仅供 AI 搜索引擎与公众参考，具体服务以正式合同为准。'
  },

  NavMenu: {
    INDUSTRIES: '行业',
    SERVICES: '服务',
    INDIVIDUALS: '个人与家庭',
    ABOUTUS: '关于我们',
    MYACCOUNT: '我的账户',

    AutomotiveInfrastructure: '汽车与基础设施',
    RealEstateConstruction: '房地产与建筑',
    LifeScience: '生命科学',
    FinancialInstitutions: '金融机构',
    SportsEntertainmentEvents: '体育、娱乐与活动',
    EnergyPower: '能源与电力',
    ManufacturingTechnology: '制造业与科技',
    FoodBeverage: '食品与饮料',
    PrivateEquityVentureCapital: '私募股权与风险投资',

    MergersAcquisitions: '并购保证及补偿保险',
    PropertyCasualty: '财产与意外险',
    CyberSecurities: '网络安全',
    GlobalClients: '全球客户',
    DirectorsOfficers: '董事及高级管理人员责任险',
    EmployeeBenefits: '员工福利',


    Career: '职业发展',
    Advisor: 'AI保险顾问',
    Events: '最新动态',
    Global: '全球网络',
    AboutSWI: '公司简介',
    Leadership: '领导团队',
  },
  individuals: {
    heroTitle: "个人及家庭",
    heroDesc: "耀达整合全球优质保险资源，以专业服务守护个人与家庭，打造全生命周期个性化保障方案，让保险成为每个家庭的安心后盾。",
    contactUs: "联系我们",
    healthProtectionSeries: "健康保障系列",
    personalMedicalPlan: {
      title: "个人医疗保障计划",
      desc: "按需定制基础医疗方案，覆盖门诊、住院、手术等核心费用，适配不同收入层级与就医习惯，报销流程便捷高效，支持多地区就医结算。"
    },
    highEndMedicalPlan: {
      title: "高端医疗尊享方案",
      desc: "打破医保局限，联动全球优质医疗资源，涵盖全球直付服务、特需、国际部门诊、私立医院、重疾绿色通道，对接多个国家及地区顶尖医疗机构。"
    },
    childrenHealthPlan: {
      title: "少儿健康守护计划",
      desc: "针对儿童常见疾病、意外就医等场景设计，提供免排队就诊通道，搭配疫苗接种保障与全球儿科专家预约服务，大幅减少就医等待，减轻家庭育儿医疗压力。"
    },
    elderlyWellBeingPlan: {
      title: "长辈安康保障计划",
      desc: "专为中老年人健康特点定制，放宽投保年龄限制，覆盖慢性病管理、老年病治疗、康复护理等费用，适配不同地区养老医疗需求。"
    },
    lifeResponsibilitySeries: {
      title: "人生责任系列",
      desc: '家庭综合健康计划：覆盖全家不同年龄段保障需求，享家庭专属费率优惠，合理配置夫妻、子女、父母等保障，适配家庭整体保障诉求。'
    },
    familyComprehensiveHealthPlan: "家庭综合健康计划：覆盖全家不同年龄段保障需求，享家庭专属费率优惠，合理配置夫妻、子女、父母等保障，适配家庭整体保障诉求。",
    travelProtectionSeries: "出行保障系列",
    travelPlans: [
      {
        title: "境内外旅行保险",
        desc: "适配单程、多程、自驾游、亲子游等不同出行场景，涵盖意外身故 / 伤残、全球医疗救援、行李丢失、行程延误等保障，保障期限灵活可选，保额按需调配。"
      },
      {
        title: "留学生专属保障计划",
        desc: "覆盖留学期间医疗就诊、意外防护、学业中断补偿、跨国紧急救援、证件遗失保障等核心需求，适配不同国家留学政策与就医环境，投保流程便捷。"
      },
      {
        title: "商务出行保障计划",
        desc: "针对商务差旅场景定制，包含航班取消 / 延误赔付、公务设备损坏保障、异地就医衔接服务，支持多频次出行年度统保，减少重复投保繁琐。"
      },
      {
        title: "境外长期居留保障",
        desc: "适配海外工作、旅居等长期停留需求，覆盖当地基础医疗、紧急救助、合规居留相关保障，贴合不同国家地区保障要求，让长期境外生活更安心。"
      }
    ],
    common: {
      learnMore: "了解更多"
    }
  },
  contactForm: {
    title: '联系我们',
    description: '给我们留言，了解耀达如何帮助您降低风险。',
    firstName: '姓名',
    lastName: '姓氏',
    jobTitle: '职位',
    contactTime: '联系时间',
    companyName: '公司名称',
    country: '国家',
    phoneNumber: '电话号码',
    email: '电子邮箱',
    howCanWeHelp: '我们能如何帮助您？',
    additionalDetails: '附加信息',
    submit: '提交',
    firstNameRequired: '请输入名字',
    lastNameRequired: '请输入姓氏',
    jobTitleRequired: '请输入职位',
    companyNameRequired: '请输入公司名称',
    countryRequired: '请选择国家',
    subjectRequired: '请选择主题',
    phoneRequired: '请输入电话号码',
    contactTimeRequired: '请输入联系时间',
    emailRequired: '请输入电子邮箱',
    invalidEmail: '电子邮箱格式不正确',
    submittedSuccess: '提交成功！',
    submitFailed: '提交失败，请稍后重试'
  },
  contactSuccess: {
    title: '我们已收到您的请求',
    description: '感谢您的留言。耀达顾问将尽快与您联系，请留意电话或邮箱。',
    backHome: '返回首页'
  },
  personal: {
    heroDesc: '面向单个自然人设计的医疗保障产品，核心是为个人在日常或特定场景下的医疗需求提供经济支持，覆盖范围通常包括普通门诊、住院、手术、药品等基础或进阶医疗费用，可根据个人健康状况、预算灵活选择保障额度与范围，本质是为个人构建专属的医疗费用风险防护屏障。',
    whyNeedInsurance: '为什么需要医疗保险?',
    targetAudience: {
      title: '为什么需要医疗保险?',
      items: [
        {
          title: '补充医保缺口',
          desc: '社会基本医疗保险有报销限额、自付比例要求，且不覆盖进口药、靶向药、私立医院诊疗等，商业医疗险可填补这些空白。'
        },
        {
          title: '应对大额医疗支出风险',
          desc: '重大疾病或意外导致的医疗费用往往超出普通家庭承受范围，商业医疗险能快速报销相关费用，缓解资金压力。'
        },
        {
          title: '满足个性化医疗需求',
          desc: '可根据自身健康状况、预算，灵活选择保障范围（如是否含门诊、生育、体检、私立医院等）和报销比例。'
        }
      ]
    },
    toCoverGaps: {
      title: '补充医保缺口',
      description: '社会基本医疗保险有报销限额、自付比例要求，且不覆盖进口药、靶向药、私立医院诊疗等，商业医疗险可填补这些空白。'
    },
    toCopeWithRisk: {
      title: '应对大额医疗支出风险',
      description: '重大疾病或意外导致的医疗费用往往超出普通家庭承受范围，商业医疗险能快速报销相关费用，缓解资金压力。'
    },
    toMeetNeeds: {
      title: '满足个性化医疗需求',
      description: '可根据自身健康状况、预算，灵活选择保障范围（如是否含门诊、生育、体检、私立医院等）和报销比例。'
    },
    coverageInclude: '保障内容有什么？',
    coverage: {
      inpatientOutpatient: '住院及门诊医疗费用',
      hospitalBed: '床位费、食宿费、陪床费',
      examination: '检查检验费',
      surgery: '手术费',
      prescriptionDrugs: '处方药、外购药、进口药',
      specialOutpatient: '特殊门诊费：放化疗、肾透析、免靶治疗',
      valueAdded: '增值服务：住院绿通、住院垫付、二次诊疗意见、健康管理咨询、线上问诊等'
    }
  },
  highEnd: {
    heroDesc: "高端医疗保险（High-End Medical Insurance）是针对高净值人群、追求高品质医疗服务需求设计的商业医疗保险产品，核心特点是突破传统医保及普通商业医疗险的限制，覆盖更广泛的医疗场景、提供更优质的服务体验和更灵活的就医选择。",
    whyNeedInsurance: "高端医疗保险为什么高端？",
    toCoverGaps: { title: "全球医疗资源", description: "直通全球顶级医院，享受优质医疗服务。" },
    toCopeWithRisk: { title: "高额保障额度", description: "千万级保额，从容应对重大疾病风险。" },
    toMeetNeeds: { title: "尊享就医体验", description: "私密就诊环境，专人陪诊，免排队困扰。" },
    coverageInclude: "高端医疗保险为什么高端？",
    coverage: {
      directBilling: {
        title: "直付服务",
        desc: "客户在合作医院就医时，无需垫付任何费用（除少数非保障项目），由保险公司与医院直接结算，避免“大额医疗费用垫付压力”。"
      },
      priorAccess: {
        title: "就医资源优先",
        desc: "可快速预约公立医院特需专家、私立医院名医，最快可支持 “24小时内门诊预约、3天内住院安排”服务。"
      },
      overseasReferral: {
        title: "海外转诊与第二诊疗意见",
        desc: "针对疑难重症（如晚期癌症、罕见病），可提供“海外专家第二诊疗意见”，避免误诊或治疗方案偏差。"
      },
      dedicatedHealth: {
        title: "专属健康管理",
        desc: "提供日常健康咨询、体检报告解读、慢性病用药提醒、术后康复指导等全周期服务。"
      },
      multilingualSupport: {
        title: "多语言支持",
        desc: "针对海外就医或外籍客户，提供多语言服务，包括就医翻译、病历翻译等。"
      }
    },
    targetAudience: {
      title: "适合人群：谁需要高端医疗保险？",
      items: [
        {
          title: "高净值人群",
          desc: "企业主、高管、自由职业者等收入较高的群体，追求 “省时、省心、高品质” 的医疗服务，不愿在就医排队、资源争夺上浪费时间。"
        },
        {
          title: "有特殊医疗需求的家庭",
          desc: ""
        },
        {
          title: "备孕 / 孕期女性",
          desc: "需要私立医院孕产服务（如和睦家、美中宜和），或希望覆盖孕产并发症风险。0-6 岁儿童家庭：重视儿童疫苗接种、日常门诊便捷性，希望快速对接儿科专家，避免公立医院儿科排队。"
        },
        {
          title: "0-6岁儿童家庭",
          desc: "重视儿童疫苗接种、日常门诊便捷性，希望快速对接儿科专家，避免公立医院儿科排队。"
        },
        {
          title: "有慢性病或重疾风险的人群",
          desc: "如糖尿病、高血压患者（需长期用药且希望用进口药），或有癌症家族史、希望覆盖海外重疾治疗的人群。"
        },
        {
          title: "常居海外或有海外就医需求的人",
          desc: "如跨国企业员工、留学生家庭，或倾向于海外先进医疗技术的人群。"
        },
        {
          title: "外籍人士",
          desc: "在华工作 / 生活的外籍人士，不享受中国医保，需通过高端医疗险覆盖在华及全球就医需求。"
        },
      ]
    }
  },
  children: {
    heroDesc: "专为 0-17 周岁未成年人设计的健康保障方案，结合儿童生理特点（免疫力较弱、易患特定疾病）和医疗需求，以 “全面医疗覆盖 + 专属优质服务” 为核心，为儿童健康建立防护线。",
    whyNeedInsurance: "为什么需要儿童专属保险？",
    targetAudience: {
      title: "为什么需要儿童专属保险？",
      items: [
        {
          title: "补充医保缺口",
          desc: "部分儿童未参保医保或医保覆盖不足，无法通过基础医保获得医疗费用报销，儿童专属保险可作为核心保障，全面覆盖诊疗支出。"
        },
        {
          title: "满足特殊就医需求",
          desc: "儿童就医需求特殊，少儿免疫力较弱，易患常见病且发病急，需要快速、优质的诊疗服务，私立医院、国际部可避免排队等待，提供专属儿科诊疗环境。"
        },
        {
          title: "应对少儿特殊医疗风险",
          desc: "应对少儿特殊医疗风险，儿童高发重疾（如白血病）的先进治疗费用高昂，普通医疗保障难以覆盖，高端医疗可全额报销。"
        },
        {
          title: "满足家长高品质育儿需求",
          desc: "满足家长高品质育儿需求，可对接全球顶尖儿科资源，提供多语言服务、个性化诊疗方案，同时涵盖疫苗接种、儿童保健等全周期健康管理，让家长更安心。"
        }
      ]
    },
    toCoverGaps: { title: "抵抗力弱易生病", description: "儿童免疫系统尚未发育成熟，就医频率高。" },
    toCopeWithRisk: { title: "意外伤害风险", description: "活泼好动，意外伤害风险相对较高。" },
    toMeetNeeds: { title: "优质医疗资源", description: "儿科专家号难挂，私立医院就医更便捷。" },
    coverageInclude: "保障亮点",
    coverage: {
      item1: "门急诊及住院医疗费用",
      item2: "儿童常见特定疾病保障",
      item3: "疫苗接种费用报销",
      item4: "儿童定期健康检查",
      item5: "意外伤害医疗保障",
      item6: "知名私立医院直付服务",
      item7: "儿科专家预约绿色通道"
    }
  },
  elderly: {
    heroDesc: "专为中老年人健康特点定制，放宽投保年龄限制，覆盖慢性病管理、老年病治疗、康复护理等费用，适配不同地区养老医疗需求。",
    whyNeedInsurance: "为什么需要老年人医疗险？",
    targetAudience: {
      title: "为什么需要给长辈规划保险？",
      items: [
        { title: "年龄增长风险增", desc: "老年人医疗需求多，慢性病（高血压、糖尿病等）发病率高，需长期门诊开药、定期检查，且面临脑卒中、癌症、意外骨折等风险，治疗周期长、费用高。" },
        { title: "慢性病管理需求", desc: "老年人投保门槛高，普通商业医疗险对健康要求严格、保费随年龄增长大幅上升。" },
        { title: "减轻子女赡养压力", desc: "减轻子女赡养压力，转移老年人医疗费用风险，避免高额医疗支出给子女带来经济负担。" }
      ]
    },
    toCoverGaps: { title: "年龄增长风险增", description: "随着年龄增长，患病风险和医疗支出显著增加。" },
    toCopeWithRisk: { title: "慢性病管理需求", description: "长期慢性病需要持续的医疗投入和管理。" },
    toMeetNeeds: { title: "投保门槛放宽", description: "专为老年人设计，健康告知相对宽松。" },
    coverageInclude: "保障内容",
    coverage: {
      item1: "一般住院医疗保险金",
      item2: "恶性肿瘤医疗保障",
      item3: "特定慢性病治疗费用",
      item4: "质子重离子医疗费用",
      item5: "住院护工费用津贴",
      item6: "家庭医生咨询服务",
      item7: "意外骨折医疗保障"
    }
  },
  life: {
    heroDesc: "家庭综合健康计划是为家庭成员（通常含夫妻、子女，部分可含父母）设计的 “打包式” 健康保障方案，以 “一人投保、全家覆盖” 为特点，整合医疗、重疾、意外等保障责任，保费通常比家庭成员单独投保更优惠，保障更提升。",
    whyNeedInsurance: "为什么需要人寿/家庭保险？",
    targetAudience: {
      title: "为什么需要？",
      items: [
        { title: "家庭经济支柱", desc: "简化投保流程，一次投保即可覆盖全家，统一管理保单，避免分别投保的繁琐手续。" },
        { title: "资产传承与保全", desc: "降低保费成本，享受家庭团购优惠，减轻多成员投保的经济压力，尤其适合多子女家庭或带父母投保的家庭。" },
      ]
    },
    toCoverGaps: { title: "家庭经济支柱", description: "保障家庭经济支柱，防止因变故导致家庭陷入困境。" },
    toCopeWithRisk: { title: "资产传承与保全", description: "合理规划资产传承，规避债务和税务风险。" },
    toMeetNeeds: { title: "全家共享保障", description: "一张保单覆盖全家，管理便捷，性价比高。" },
    coverageInclude: "核心保障",
    coverage: {
      item1: "身故及全残保险金",
      item2: "定期寿险/终身寿险选择",
      item3: "家庭成员共享保额",
      item4: "重大疾病豁免保费",
      item5: "生活费用补偿金",
      item6: "子女教育金储备功能",
      item7: "保单贷款流动性支持"
    }
  },
  travel: {
    heroDesc: "针对企业员工或个体经营者 “商务差旅” 场景设计的保障方案，保障期限与差旅时长匹配（如 1-15 天，可按次或按月投保），以 “意外防护 + 商务医疗 + 差旅损失补偿” 为核心，投保主体可为企业（批量为员工投保）或个人（自由职业者），侧重覆盖商务场景专属风险。",
    whyNeedInsurance: "为什么需要旅行保险？",
    targetAudience: {
      title: "为什么需要？",
      items: [
        { title: "旅途意外不可控", desc: "商务出行风险特殊，频繁往返、陌生城市办公易遭遇交通意外、突发疾病，还可能因行程意外影响商务活动。" },
        { title: "境外医疗费用高", desc: "转移企业用工风险，员工商务出行期间受伤或生病，企业需承担相关费用和赔偿，该计划可减少企业用工成本和法律风险。" },
        { title: "签证必备要求", desc: "适配商务场景需求，常规保险不覆盖 “商务专属损失”（如商务设备丢失、会议取消损失），该计划可针对性补充。" }
      ]
    },
    toCoverGaps: { title: "旅途意外不可控", description: "交通事故、航班延误、行李丢失等意外频发。" },
    toCopeWithRisk: { title: "境外医疗费用高", description: "海外就医费用昂贵，紧急救援不可或缺。" },
    toMeetNeeds: { title: "签证必备要求", description: "部分国家办理签证强制要求购买旅行保险。" },
    coverageInclude: "全面保障",
    coverage: {
      item1: "意外身故及伤残保障",
      item2: "医疗费用补偿（含门诊住院）",
      item3: "紧急医疗运送和送返",
      item4: "旅行延误及行李丢失",
      item5: "个人责任保险",
      item6: "银行卡盗刷保障",
      item7: "24小时全球紧急救援"
    }
  },
  student: {
    heroDesc: '留学生专属保障计划是针对出国留学生设计的长期保障方案，以 “海外医疗 + 学业保障 + 安全防护” 为核心，为留学期间的突发意外和疾病医疗需求保驾护航。',
    targetAudience: {
      title: '为什么需要?',
      items: [
        {
          title: '补充医保缺口',
          desc: '海外医疗成本极高，欧美、澳洲等国家医疗费用远超国内，留学生通常无法享受当地免费医疗，无保险可能面临 “天价账单”。'
        },
        {
          title: '应对意外风险',
          desc: '留学生面临多元风险，除医疗风险外，还可能遭遇意外、学业中断（因疾病 / 意外无法上课）、安全问题（失联、自然灾害），常规保险保障不足。'
        },
        {
          title: '学业中断保障',
          desc: '满足高校强制要求，多数海外高校将 “购买符合要求的医疗保险” 作为入学前提，未投保或保险不符合标准可能无法注册学籍。'
        }
      ]
    },
    toCoverGaps: {
      title: '补充医保缺口',
      description: '海外就医费用高昂，留学生医保往往覆盖有限，商业保险可填补空白。'
    },
    toCopeWithRisk: {
      title: '应对意外风险',
      description: '留学期间面临交通、运动等意外风险，提供全方位意外保障。'
    },
    toMeetNeeds: {
      title: '学业中断保障',
      description: '因意外或疾病导致学业中断，提供学费补偿，减轻家庭经济负担。'
    },
    coverage: {
      item1: '意外身故及伤残',
      item2: '医疗费用补偿',
      item3: '紧急医疗救援',
      item4: '旅行延误及取消',
      item5: '个人财务及证件',
      item6: '学业中断补偿',
      item7: '个人责任'
    }
  },
  business: {
    heroDesc: '针对企业员工或个体经营者 “商务差旅” 场景设计的保障方案，保障期限与差旅时长匹配（如 1-15 天，可按次或按月投保），以 “意外防护 + 商务医疗 + 差旅损失补偿” 为核心，投保主体可为企业（批量为员工投保）或个人（自由职业者），侧重覆盖商务场景专属风险。',
    targetAudience: {
      title: '为什么需要?',
      items: [
        {
          title: '行程变动频繁',
          desc: '商务出行风险特殊，频繁往返、陌生城市办公易遭遇交通意外、突发疾病，还可能因行程意外影响商务活动。'
        },
        {
          title: '公务设备保障',
          desc: '转移企业用工风险，员工商务出行期间受伤或生病，企业需承担相关费用和赔偿，该计划可减少企业用工成本和法律风险。'
        },
        {
          title: '紧急医疗需求',
          desc: '适配商务场景需求，常规保险不覆盖 “商务专属损失”（如商务设备丢失、会议取消损失），该计划可针对性补充。'
        }
      ]
    },
    toCoverGaps: {
      title: '行程变动频繁',
      description: '航班延误、取消频繁，影响商务行程，保险提供相应赔付。'
    },
    toCopeWithRisk: {
      title: '公务设备保障',
      description: '笔记本电脑等公务设备损坏或丢失需保障，降低商务损失。'
    },
    toMeetNeeds: {
      title: '紧急医疗需求',
      description: '异地突发疾病需及时救治及转运，确保商务人员安全。'
    },
    coverage: {
      item1: '意外身故及伤残',
      item2: '医疗费用补偿',
      item3: '紧急医疗运送',
      item4: '旅程延误',
      item5: '行李延误及丢失',
      item6: '公务设备损失',
      item7: '个人责任'
    }
  },
  residence: {
    heroDesc: '针对 “境外长期居住” 人群（如海外侨民、外派工作者、长期陪读家长，居留时长通常 6 个月以上）设计的长期健康保障方案，以 “全面医疗覆盖 + 当地服务适配” 为核心，可覆盖境外长期生活中的医疗、意外等风险。',
    targetAudience: {
      title: '为什么需要?',
      items: [
        {
          title: '长期生活风险',
          desc: '境外长期居住医疗需求持续，长期居留期间面临慢性病管理、突发疾病、意外等风险，当地医疗体系复杂，费用高昂，需专属保障覆盖。'
        },
        {
          title: '当地社保不足',
          desc: '常规保险不适配长期居留场景，旅游保险保障期限短，普通商业医疗险境外保障有限，该计划可满足长期、稳定的保障需求。'
        },
        {
          title: '签证居留要求',
          desc: '适配当地医疗服务，提供符合居留地医疗体系的报销流程、就医资源对接，解决语言沟通、流程不熟悉等问题。'
        }
      ]
    },
    toCoverGaps: {
      title: '长期生活风险',
      description: '长期在海外生活，面临各类生活意外与疾病风险，需要全面保障。'
    },
    toCopeWithRisk: {
      title: '当地社保不足',
      description: '当地社会保障可能无法完全覆盖外国人，商业保险提供补充。'
    },
    toMeetNeeds: {
      title: '签证居留要求',
      description: '部分国家居留许可要求必须购买特定保险，满足合规要求。'
    },
    coverage: {
      item1: '意外身故及伤残',
      item2: '医疗费用补偿',
      item3: '紧急医疗救援',
      item4: '每日住院津贴',
      item5: '亲友慰问探访',
      item6: '个人责任',
      item7: '遗体/骨灰送返'
    }
  },
  contactUsIcon: {
    ContactUs: '联系我们',
    Submit: '提交',
    PartnerSuppliers: '合作伙伴供应商'
  }
}
